export default {
      id: "menu__geoitems_fill-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__geoitems_fill",
      toString: function () {
        return this.url;
      }
    }